import './App.css';

import * as React from 'react';

import Router from './components/Router';

declare var abp: any;
export interface IAppProps {
  
}

class App extends React.Component<IAppProps> {
  async componentWillMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const checkLoginParam = urlParams.get('checkLogin');
    if (checkLoginParam === '1') {
      const quoteIdParam = urlParams.get('quoteId');
      const quoteNumberParam = urlParams.get('quoteNumber');
      const quoteStatusParam = urlParams.get('quoteStatus');
      const isNewParam = urlParams.get('isNew');
      const checkLoginParam = urlParams.get('checkLogin');
      const redirectInfo = {
        redirectTo: 'cart-item',
        quoteId: quoteIdParam,
        quoteNumber: quoteNumberParam,
        quoteStatus: quoteStatusParam,
        isNew: isNewParam,
        checkLogin: checkLoginParam
      }
      if (!abp.session.userId) {
        localStorage.setItem('redirectInfo', JSON.stringify(redirectInfo));
      }
    }
  }

  public render() {
    return (
      <div>
        <Router />
      </div>
    );
  }
}

export default App;
